<template>
  <div class="page-head">
    <a href="javascript:;" class="head-logo">
      <img class="logo-100" src="../assets/logo-s.png" alt="" @click="gohome">
    </a>
    <div class="head-menus-div">
      <div class="head-menus">
        <div class="menu-2 menu-index" v-if="['/down', '/'].indexOf(path) > -1">
          <transition-group name="list" tag="div">
            <router-link class="menu-one" :class="{'active-menu-one': path === '/home'}" to="/home" key="o1">工作台</router-link>
            <router-link class="menu-one" :class="{'active-menu-one': path === '/down'}" to="/down" key="o2">资料库</router-link>
            <a :class="{'active-menu-one': active_menu_index === 2}" href="http://www.reemii.cn" key="o3" class="menu-one" @click="chooseMenuIndex(2)">
              关于我们
            </a>
          </transition-group>
        </div>
        <template v-if="path.indexOf('/home/cycle') > -1">
          <a href="javascript:;" class="menu-1" @click="clickLeftMenu('left')" :class="{'menu-1-active': show_menu === 'left'}" v-if="solutionStatus > 10 || solutionStatus === 10">
            <i class="iconfont icon-dingdan"></i>
          </a>
          <div class="menu-2">
            <transition-group name="list" tag="div">
              <a :class="{'active-menu-one': active_menu === menu.route_name}" href="javascript:;" key="index" class="menu-one" v-for="(menu, index) in left_menus" @click="chooseMenu(menu)" v-if="solutionStatus > menu.minStatus || solutionStatus === menu.minStatus">
                {{menu.leabel}}
              </a>
            </transition-group>
          </div>
          <div class="fg-line" v-if="solutionStatus > 30 || solutionStatus === 30">
          </div>
          <a  href="javascript:;"class="menu-1" @click="clickLeftMenu('right')" :class="{'menu-1-active': show_menu === 'right'}" v-if="solutionStatus > 30 || solutionStatus === 30">
            <i class="iconfont icon-shuju"></i>
          </a>
          <div class="menu-2">
            <transition-group name="list" tag="div">
              <a :class="{'active-menu-one': active_menu === menu.route_name}" key="index + '-right'" href="javascript:;" class="menu-one" v-for="(menu, index) in right_menus" v-if="solutionStatus > menu.minStatus || solutionStatus === menu.minStatus" @click="chooseMenu(menu)">
                {{menu.leabel}}
              </a>
            </transition-group>
          </div>
        </template>
        <template v-if="path.indexOf('/home/single') > -1">
          <a href="javascript:;" class="menu-1" @click="clickLeftMenu('left')" :class="{'menu-1-active': show_menu === 'left'}" v-if="preStatus > 10 || preStatus === 10">
            <i class="iconfont icon-dingdan"></i>
          </a>
          <div class="menu-2">
            <transition-group name="list" tag="div">
              <a :class="{'active-menu-one': active_menu === menu.route_name}" href="javascript:;" key="index" class="menu-one" v-for="(menu, index) in left_menus_p" @click="chooseMenu(menu)" v-if="preStatus > menu.minStatus || preStatus === menu.minStatus">
                {{menu.leabel}}
              </a>
            </transition-group>
          </div>
          <div class="fg-line" v-if="preStatus > 30 || preStatus === 30">
          </div>
          <a  href="javascript:;"class="menu-1" @click="clickLeftMenu('right')" :class="{'menu-1-active': show_menu === 'right'}" v-if="preStatus > 30 || preStatus === 30">
            <i class="iconfont icon-shuju"></i>
          </a>
          <div class="menu-2">
            <transition-group name="list" tag="div">
              <a :class="{'active-menu-one': active_menu === menu.route_name}" key="index + '-right'" href="javascript:;" class="menu-one" v-for="(menu, index) in right_menus_p" v-if="preStatus > menu.minStatus || preStatus === menu.minStatus" @click="chooseMenu(menu)">
                {{menu.leabel}}
              </a>
            </transition-group>
          </div>
        </template>
        <template v-if="path.indexOf('/single_home/single') > -1">
          <a href="javascript:;" class="menu-1" @click="clickLeftMenu('left')" :class="{'menu-1-active': show_menu === 'left'}" v-if="preStatus > 10 || preStatus === 10">
            <i class="iconfont icon-dingdan"></i>
          </a>
          <div class="menu-2">
            <transition-group name="list" tag="div">
              <a :class="{'active-menu-one': active_menu === menu.route_name}" href="javascript:;" key="index" class="menu-one" v-for="(menu, index) in left_menus_ps" @click="chooseMenu(menu)" v-if="preStatus > menu.minStatus || preStatus === menu.minStatus">
                {{menu.leabel}}
              </a>
            </transition-group>
          </div>
          <div class="fg-line" v-if="preStatus > 30 || preStatus === 30">
          </div>
          <a  href="javascript:;"class="menu-1" @click="clickLeftMenu('right')" :class="{'menu-1-active': show_menu === 'right'}" v-if="preStatus > 30 || preStatus === 30">
            <i class="iconfont icon-shuju"></i>
          </a>
          <div class="menu-2">
            <transition-group name="list" tag="div">
              <a :class="{'active-menu-one': active_menu === menu.route_name}" key="index + '-right'" href="javascript:;" class="menu-one" v-for="(menu, index) in right_menus_ps" v-if="preStatus > menu.minStatus || preStatus === menu.minStatus" @click="chooseMenu(menu)">
                {{menu.leabel}}
              </a>
            </transition-group>
          </div>
        </template>
      </div>
    </div>
    <template v-if="path.indexOf('/single_home/single') > -1">
      <div class="head-user">
      <div class="user-info">
        <span class="head-btn-a" @click="goOther">{{path.indexOf('adjust_home') ? '配单' : '流程'}}</span>
      </div>
    </div>
      <div class="head-user">
        <div class="user-info qh-btn">
          <span class="head-btn-a">{{getLabel(oilArea)}}</span>
          <div class="choose-ps" v-if="pszxDatas.length > 0">
            <a href="javascript:;" v-for="item in pszxDatas" @click="oilArea = item.key">{{item.label}}</a>
          </div>
        </div>
      </div>
    </template>
    <template>
      <user-info v-if="path.indexOf('oil_chart') === -1 && path.indexOf('gas_map') === -1"></user-info>
    </template>
    <template v-if="!noLogin">
      <div class="head-user" v-if="path.indexOf('oil_chart') > -1 || path.indexOf('gas_map') > -1">
        <div class="user-info">
          <a href="javascript:;" @click="goHaveFun">Have Fun</a>
        </div>
      </div>
    </template>
    <div style="display: none">
      {{path}}
    </div>
  </div>
</template>

<script>
import UserInfo from '@/components_bit/UserInfo'

export default {
  components: {
    UserInfo
  },
  props: ['noLogin'],
  data () {
    return {
      active_menu_index: null,
      show_menu: '',
      active_menu: '',
      left_menus: [],
      right_menus: [],
      left_menus_p: [],
      right_menus_p: [],
      left_menus_ps: [],
      right_menus_ps: [],
      other_menus: [],
      menus: [{
        leabel: '订单相关信息',
        minStatus: 10,
        type: 'left',
        route_name: 'source_data'
      },
      {
        leabel: '车辆相关信息',
        minStatus: 30,
        type: 'right',
        route_name: 'cars'
      },
      {
        leabel: '路径相关信息',
        minStatus: 40,
        type: 'right',
        route_name: 'car_route'
      },
      {
        leabel: '进销存数据',
        type: 'pre_left',
        minStatus: 5,
        route_name: 'prediction_check'
      },
      {
        leabel: '分析预测',
        type: 'pre_left',
        minStatus: 20,
        route_name: 'prediction'
      },
      {
        leabel: '每日订单-加油站',
        type: 'pre_right',
        minStatus: 30,
        route_name: 'prediction_station'
      },
      {
        leabel: '每日订单-车辆',
        type: 'pre_right',
        minStatus: 30,
        route_name: 'prediction_car'
      },
      {
        leabel: '进销存数据',
        type: 'sin_left',
        minStatus: 5,
        route_name: 'single.prediction_check'
      },
      {
        leabel: '分析预测',
        type: 'sin_left',
        minStatus: 20,
        route_name: 'single.prediction'
      },
      {
        leabel: '每日订单-加油站',
        type: 'sin_right',
        minStatus: 30,
        route_name: 'single.prediction_station'
      },
      {
        leabel: '每日订单-车辆',
        type: 'sin_right',
        minStatus: 30,
        route_name: 'single.prediction_car'
      }]
    }
  },
  computed: {
    pszxDatas: {
      get () {
        let showData = []
        this.$store.getters.canChoosePSZXs.forEach((item) => {
          if (item.key !== this.oilArea) {
            showData.push(item)
          }
        })
        return showData
      }
    },
    path: {
      get () {
        let path = this.$store.state.route.path
        let vm = this
        this.active_menu = this.$router.history.current.name
        this.menus.forEach(function (item, index) {
          if (vm.active_menu === item.route_name) {
            vm.show_menu = (item.type.indexOf('pre_') > -1 || item.type.indexOf('sin_') > -1) ? item.type.slice(4) : item.type
          }
        })
        return path
      }
    },
    solutionStatus: {
      get () {
        return this.$store.getters.solutionStatus
      }
    },
    oilArea: {
      get () {
        return this.$store.getters.oilArea
      },
      set (value) {
        this.$store.dispatch('setOilArea', value)
      }
    },
    preStatus: {
      get () {
        return this.$store.getters.preStatus
      }
    }
  },
  created () {
    let vm = this
    this.menus.forEach(function (item) {
      if (item.type === 'left') {
        vm.left_menus.push(item)
      } else if (item.type === 'right') {
        vm.right_menus.push(item)
      } else if (item.type === 'pre_left') {
        vm.left_menus_p.push(item)
      } else if (item.type === 'pre_right') {
        vm.right_menus_p.push(item)
      } else if (item.type === 'sin_left') {
        vm.left_menus_ps.push(item)
      } else if (item.type === 'sin_right') {
        vm.right_menus_ps.push(item)
      }
    })
  },
  methods: {
    goOther () {
      if (this.path.indexOf('adjust_home') > -1) {
        window.open('/#/single_home/single')
      } else {
        window.open('/#/adjust_home')
      }
      window.close()
    },
    getLabel (key) {
      let label = ''
      this.$store.getters.canChoosePSZXs.forEach((item) => {
        if (key === item['key']) {
          label = item.label
        }
      })
      return label
    },
    goHaveFun () {
      this.$router.push({ name: 'single_home' })
    },
    gohome () {
      this.$router.push({ name: 'index' })
    },
    clickLeftMenu (key) {
      this.show_menu = key
    },
    chooseMenu (menu) {
      this.active_menu = menu.route_name
      this.show_menu = menu.type.indexOf('pre') > -1 ? menu.type.slice(4) : menu.type
      this.$router.push({ name: menu.route_name })
    },
    chooseMenuIndex (index) {
      this.active_menu_index = index
    }
  }
}
</script>

<style scoped lang="less">
@import '../style/base.less';
@left-right-width: 13em;
.qh-btn {
  position: relative;
  .choose-ps {
    position: absolute;
    top: 1.2rem;
    right: 0;
    display: none;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #012e53;
    a {
      transition: 0.3s;
      font-size: 0.8rem;
      line-height: 1.2rem;
      letter-spacing: 3px;
      height: 2rem;
      padding: 0 1rem;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border-bottom: 0.31em solid #012e53;
    }
    a:hover {
      background-color: #081633;
      border-bottom: 0.31em solid #00ccff;
    }
  }
}
.head-btn-a {
  background-color: #012e53;
  font-size: 0.8rem;
  letter-spacing: 3px;
  line-height: 1.2rem;
  border-radius: 0.2rem;
  padding: 0 1rem;  
}
.qh-btn:hover {
  .choose-ps {
    display: flex;
  }
}
.menu-index {
  height: 2.63em;
  .menu-one {
    margin: 2px 4em 0;
    font-size: 1.2em;
  }
  .active-menu-one {
    color: @line-color;
    border-bottom: 0.31em solid @line-color;
    padding-bottom: 0.6em;
  }
}
.page-head {
  height: 6.13em;
  background-color: @bak-color-1;
  display: flex;
  flex-direction: row;
}
.head-logo {
  width: @left-right-width;
  align-items: center;
  justify-content: center;
  display: flex;
  padding: 0 0 0.5em 1.5em;
}
.logo-100 {
  height: 5.6em;
}
.head-menus-div {
  flex: 1;
  display: flex;
  flex-direction:column-reverse;
}
.list-enter-active, .list-leave-active {
  transition: all 1s;
}
.list-enter, .list-leave-to {
  opacity: 0;
}
.head-menus {
  height: 2.3rem;
  color: #fff;
  display: flex;
  flex-direction:row;
  justify-content:center;
}
.fg-line {
  width: 2px;
  margin:-0.31em 1.625em 1.13em;
  background-color: #fff;
}
.fg-line-2 {
  width: 2px;
  margin:0.625em 0.44em;
  background-color: #fff;
}
.menu-1 {
  transition: 0.3s;
  display: flex;
  flex-direction:row;
  margin: 0 0.625em;
  color: #fff;
  line-height: 1;
  padding-bottom: 1.13em;
  .iconfont {
    font-size: 1.56em;
  }
  span {
    font-size: 1.5em;
    margin-left: 0.625em;
  }
}
.menu-1-active {
  color: @line-color;
}
.menu-2 {
  display: flex;
  flex-direction:row;
}
.menu-one {
  transition: 0.3s;
  color: #fff;
  flex: 1;
  font-size: 0.9em;
  word-break: keep-all;
  white-space: nowrap;
  margin: 2px 0.625em 0;
}
.active-menu-one {
  color: @line-color;
  border-bottom: 0.31em solid @line-color;
  padding-bottom: 1.15em;
}
.head-user {
  display: flex;
  width: @left-right-width;
  flex-direction:column-reverse;
}
.user-info {
  margin:0 1.88em 0.94em 0;
  color: #fff;
  display: flex;
  flex-direction:row;
  align-items: center;
  justify-content: flex-end;
  a {
    color: #fff;
    margin-left: 0.5rem;
    font-size: 1rem;
  }
  i {
    font-size: 1.8em;
  }
}
</style>



// WEBPACK FOOTER //
// PageHead.vue?0467fd6a